// This file is automatically generated. Do not edit manually.

import { PurchaseOrderLineAggregatedSourceView } from "src/api/generated/erp/db/types/tables/purchaseOrderLineAggregatedSourceView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseOrderLineSourcesDataGridApi {
	export async function getData(args: {
		purchaseOrderLineId: number;
	}): Promise<Array<PurchaseOrderLineAggregatedSourceView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/purchaseOrderLineSourcesDataGrid/getData",
			method: "POST",
			data: {
				purchaseOrderLineId: args.purchaseOrderLineId,
			},
		});
		return response as Array<PurchaseOrderLineAggregatedSourceView>;
	}
}
